import { render, staticRenderFns } from "./DashView.vue?vue&type=template&id=4caf4936&scoped=true&"
import script from "./DashView.vue?vue&type=script&lang=js&"
export * from "./DashView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caf4936",
  null
  
)

export default component.exports